module.exports = __webpack_public_path__ + "static/media/icon-4.24ff79d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pc/icon-4.png
// module id = 299
// module chunks = 0